import React, { useEffect, useState, useRef, useCallback} from 'react';
import { createRoot } from 'react-dom/client';
import { GoogleMap, LoadScript, GroundOverlay, InfoWindow } from '@react-google-maps/api';
import MapControls from './MapControls';
import $ from 'jquery';

import colorbar1 from '../logos/colorbar.png';
import colorbar2 from '../logos/sfrcm633.png';
import cmap1 from '../JSON/reverse_cmap.json';
import cmap2 from '../JSON/sfrcm633_reverse_cmap.json';
import config from '../JSON/regions.json';
import { useSearchParams } from 'react-router-dom'


import states from '../JSON/us-state-boundaries.json'

const libraries = ['drawing&v=3.64'];

const mid = 'eb5e1352a8e4c7f2';

const Map = ({ images, region }) => {
    const [controlsRoot, setControlsRoot] = useState(null);
    const [timeRoot, setTimeRoot] = useState(null);
    const [currBounds, setBounds] = useState(null);
    const [rectangleBool, setRectangleBool] = useState(false);
    const [countyBoundaries, setCountyBoundaries] = useState(false);
    const [drawingManager, setDrawingManager] = useState(null);
    const [width, setWidth] = useState(0);
    const [height, setHeight] = useState(0);
    const [map, setMap] = useState(null);
    const [label, setLabel] = useState(null);
    const [infoWin, setInfoWin] = useState(null);
    const [colorbar, setColorbar] = useState(null);
    const [cmap, setCmap] = useState(null);
    const [popupClass, setPopupClass] = useState(null);
    const [popup, setPopup] = useState(null);
    const [colorbarRoot, setColorbarRoot] = useState(null);
    const cmapRef = useRef(cmap);



    const [searchParams, setSearchParams] = useSearchParams();


    const urlIndex = parseInt(searchParams.get("img"));
    const [index, setIndex] = useState(urlIndex);   
    const indexRef = useRef(index);

    const updateURL = useCallback(() => {
        setSearchParams(prev => {
            const params = new URLSearchParams(prev);
            params.set('img', indexRef.current);
            params.set('opacity', opacityRef.current);
            if (map) {
                const center = map.getCenter();
                const zoom = map.getZoom();
                params.set('lat', center.lat().toFixed(2));
                params.set('lng', center.lng().toFixed(2));
                params.set('zoom', zoom.toFixed(2));
            }
            return params;
        });
    }, [map]);
    


   useEffect(() => {
    indexRef.current = index;
    setSearchParams(prev => {
      const params = new URLSearchParams(prev);
      params.set("img", index);
      return params;
    });
  }, [index, updateURL]);


  const [transparency, setTransparency] = useState(() => {
    const urlTransparency = parseInt(searchParams.get("opacity"));
    if(!isNaN(urlTransparency) && urlTransparency >= 0 && urlTransparency <= 100){
        return urlTransparency;
    }
    return 70;
    });
    const opacityRef = useRef(transparency);

  useEffect(() => {
    opacityRef.current = transparency;
    updateURL();
  }, [transparency, updateURL]);





    const [center, setCenter] = useState(() => {
        const lat = parseFloat(searchParams.get("lat"));
        const lng = parseFloat(searchParams.get("lng"));
        if (!isNaN(lat) && !isNaN(lng)) {
            return { lat, lng };
        }
        return config[region]["center"];
    });
    
    const [zoom, setZoom] = useState(() => {
        const z = parseFloat(searchParams.get("zoom"));
        return !isNaN(z) ? z : config[region]["zoom"];
    });

    


    // const [mousePos, setMousePos] = useState({x: 0, y: 0});
    // const [winCont, setWinCont] = useState('<p>Click on map to see SFR values.</p>');


    /* Set width to be 400 less than window size for NavRight
       Set height to 170 less than window height for Navbar. */
    useEffect(() => {
        function handleResize() {
            setWidth(Math.max(document.documentElement.clientWidth - 400, 550));
            setHeight(Math.max(document.documentElement.clientHeight - 170, 400));
        }

        setWidth(Math.max(document.documentElement.clientWidth - 400), 550);
        setHeight(Math.max(document.documentElement.clientHeight - 170), 400);

        // // // temp code
        // if((region === "conus" || region === "msfr" || region === "alaska")) {
        //     if (images && images[index] && images[index][0]) {
        //         const imgDateString = images[index][0].match(/[0-9]{8}/)[0];
        //         const imgDate = new Date (
        //             parseInt(imgDateString.substring(0,4)),
        //             parseInt(imgDateString.substring(4,6)) - 1,  //js months 0-indexed
        //             parseInt(imgDateString.substring(6,8)),
        //         );
        //         const cutoffDate = new Date(2025, 11, 1); //js months 0-indexed

        //         if (imgDate < cutoffDate) {
        //             setColorbar(colorbar1);
        //             setCmap(cmap1);
        //         } else {
        //             setColorbar(colorbar2);
        //             setCmap(cmap2);
        //         }
        //     } 

        // } 
        // //other regions default behaviour
        // else {
        //     if (config[region].colorbar === 2) {
        //         setColorbar(colorbar2);
        //         setCmap(cmap2);
        //     }
        //     else {
        //         setColorbar(colorbar1);
        //         setCmap(cmap1);
        //     }
        // } 
        // temp code
        if (region === "msfr") {
            setColorbar(colorbar1);
            setCmap(cmap1);            
        }
        else {
            if (images && images[index] && images[index][0]) {
                const imgDateString = images[index][0].match(/[0-9]{8}/)[0];
                const imgDate = new Date (
                    parseInt(imgDateString.substring(0,4)),
                    parseInt(imgDateString.substring(4,6)) - 1,  //js months 0-indexed
                    parseInt(imgDateString.substring(6,8)),
                );

                const cutoffDate = new Date(2025, 11, 1); //js months 0-indexed
                const cutoffDate1 = new Date(2021, 7, 1); //js months 0-indexed
                if (imgDate < cutoffDate && imgDate > cutoffDate1) {
                    setColorbar(colorbar1);
                    setCmap(cmap1);
                } else {
                    setColorbar(colorbar2);
                    setCmap(cmap2);
                }
            }
        }

        window.addEventListener('resize', handleResize);
        // window.addEventListener('onMouseMove', handleonMouseMove);
    }, [region, index, images])

    /* Function to get parameters from MapControls */
    const getParams = (params) => {
        setIndex(params.index);
        setTransparency(params.transparency);
        setRectangleBool(params.rectangle);
        setCountyBoundaries(params.countyBoundaries);
    }

    /* Once Map exists, render Map controls */
    useEffect(() => {
        if (controlsRoot) {
            controlsRoot.render(
                <div>
                    <MapControls getParams={getParams} images={images} bounds={currBounds} rectangle={rectangleBool} region={region}  index={index} setIndex={setIndex} initialTransparency={transparency}
                    />
                </div>
            );
        }
    }, [images, controlsRoot, rectangleBool, currBounds, region, index, setIndex, transparency])

    /* Once Map exists, render text showing current image info */
    useEffect(() => {
        if (timeRoot && images && images[index] && images[index][0]) {
            timeRoot.render(
                <div style={{ padding: 5, backgroundColor: "#fff" }}>
                    {imgInfo(images[index][0], region).join(' ')}
                </div>
            );
        }
        else if (timeRoot) {
            timeRoot.render(
                <div style={{ padding: 5, backgroundColor: "#fff" }}>
                    No Images Match Those Parameters
                </div>
            );
        }
    }, [images, index, timeRoot])

    /* Change drawing mode based on rectangle bool */
    useEffect(() => {
        if (drawingManager) {
            if (rectangleBool) {
                drawingManager.setDrawingMode(window.google.maps.drawing.OverlayType.RECTANGLE);
            }
            else {
                drawingManager.setDrawingMode(null);
            }
        }
    }, [rectangleBool, drawingManager])

    /* Buffer images */
    useEffect(() => {
        if (images && images[index]) {
            var preload = [];
            var preloadSize = 3;
            for (let i = 1; i <= preloadSize; i++) {
                preload[i] = new Image();
                preload[i].src = images[(index + i) % images.length][0];
            }
        }
    }, [index, images])

    useEffect(() => {
        if (map && map.getMapCapabilities().isDataDrivenStylingAvailable) {
            var featureLayer = map.getFeatureLayer("ADMINISTRATIVE_AREA_LEVEL_2")
            if (featureLayer.isAvailable) {
                featureLayer.style = ({ feature }) => {
                    return {
                        strokeColor: "#333333",
                        strokeOpacity: (map.getZoom() >= 5 && countyBoundaries) ? 0.5 : 0
                    }
                }
            }
        }
    }, [map, countyBoundaries])

    useEffect(() => {
        if (map && map.getMapCapabilities().isDataDrivenStylingAvailable) {
            //console.log(map.getZoom())
            var featureLayer = map.getFeatureLayer("ADMINISTRATIVE_AREA_LEVEL_1")
            if (featureLayer.isAvailable) {
                featureLayer.style = ({ feature }) => {
                    return {
                        strokeColor: '#000000',
                        strokeOpacity: ((region !== "conus" && region !== "msfr") && map.getZoom() >= 5) ? 1.0 : 0,
                        strokeWeight: .55,
                        fillOpacity: 0,
                                        
                    }
                }
            }
        }
    }, [map])
    

    useEffect(() => {
        if (map) {
            var paths = []
            for (let i = 0; i < states.length; i++) {
                var coords = states[i]['st_asgeojson']['geometry']['coordinates']
                for (let j = 0; j < coords.length; j++) {
                    var path = coords[j]
                    if (path.length === 1) {
                        path = path[0]
                    }
                    var latLngPath = []
                    for (let k = 0; k < path.length; k++) {
                        latLngPath.push(new window.google.maps.LatLng(path[k][1], path[k][0]))
                    }
                    paths.push(latLngPath)
                }
            }

            var polygons = new window.google.maps.Polygon({
                paths: paths,
                clickable: false,
                geodesic: false,
                // strokeColor: '#5A5A5A',
                strokeColor: '#000000',
                strokeOpacity: 1.0,
                strokeWeight: 0.4,
                fillOpacity: 0,
                map: map
            });
        }
    }, [map])

    useEffect(() => {
        setLabel((prev) => {
            if (prev) {
                prev.setMap(null)
            }
            return prev
        })
    }, [index, images])

    const handleGroundOverlayClick = (e, latlng, img) => {
        //console.log(e);
        var bounds = img[1]
        if (bounds.west > latlng.lng) {
            latlng.lng += 360
        }
        if (bounds.east < latlng.lng) {
            latlng.lng -= 360
        }
        var x = (latlng.lng - bounds.west) / (bounds.east - bounds.west)
        var y = (bounds.north - latlng.lat) / (bounds.north - bounds.south)

        var imgURL = img[0];
        const imgEl = new Image();
        imgEl.src = imgURL;
        imgEl.crossOrigin = "Anonymous";

        imgEl.onload = function () {
            const canvas = document.createElement('canvas');
            canvas.width = imgEl.width;
            canvas.height = imgEl.height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(imgEl, 0, 0);
            const pixelData = ctx.getImageData(x * imgEl.width, y * imgEl.height, 1, 1).data;

            const obj = {
                red: pixelData[0],
                green: pixelData[1],
                blue: pixelData[2],
                alpha: pixelData[3],
            }
            //console.log("pixelData: " + JSON.stringify(obj));


            if(obj.alpha === 255) {
                delete obj.alpha
                var str = JSON.stringify(obj)
                str = str.replaceAll("\"", "'")
                var sfr = cmapRef.current[str];
                var ssfr = '', ssfr1, ssfr6, ssfr10, ssfr14, ssfr18, ssfr25, ssfr35, ssfrs;
                if (sfr === -0.01 || sfr === -0.02)  {
                    ssfr = '0.0 in/hr';
                    ssfrs = ssfr;
                }
                else if (sfr === 0)  {
                    ssfr = '<0.0004 in/hr';
                    ssfrs = ssfr;
                }
                else if (sfr === 10)  {
                    ssfr = '\u2265' + '0.4 in/hr';
                    ssfr1 = (Math.round(sfr / 25 * 1000) / 1000).toFixed(3);
                    ssfr6 = (Math.round(sfr / 25 * 6 * 100) / 100).toFixed(2)
                    ssfr10 = (Math.round(sfr / 25 * 10 * 100) / 100).toFixed(2)
                    ssfr14 = (Math.round(sfr / 25 * 14 * 100) / 100).toFixed(2)
                    ssfr18 = (Math.round(sfr / 25 * 18 * 100) / 100).toFixed(2)
                    ssfr25 = (Math.round(sfr / 25 * 25 * 100) / 100).toFixed(2)
                    ssfr35 = (Math.round(sfr / 25 * 35 * 100) / 100).toFixed(2)
                    ssfrs = ssfr1 + ' (LE)</br>' + ssfr6 + '&nbsp&nbsp (6:1)</br>' + ssfr10 + '&nbsp&nbsp (10:1)</br>';
                    ssfrs = ssfrs + ssfr14 + '&nbsp&nbsp (14:1)</br>' + ssfr18 + '&nbsp&nbsp (18:1)</br>';
                    ssfrs = ssfrs + ssfr25 + '&nbsp&nbsp (25:1)</br>' + ssfr35 + '&nbsp&nbsp (35:1)</br>';
                }
                else if (sfr > 10) {
                    ssfr = '>0.4 in/hr'
                    ssfr1 = (Math.round(sfr / 25 * 1000) / 1000).toFixed(3);
                    ssfr6 = (Math.round(sfr / 25 * 6 * 100) / 100).toFixed(2)
                    ssfr10 = (Math.round(sfr / 25 * 10 * 100) / 100).toFixed(2)
                    ssfr14 = (Math.round(sfr / 25 * 14 * 100) / 100).toFixed(2)
                    ssfr18 = (Math.round(sfr / 25 * 18 * 100) / 100).toFixed(2)
                    ssfr25 = (Math.round(sfr / 25 * 25 * 100) / 100).toFixed(2)
                    ssfr35 = (Math.round(sfr / 25 * 35 * 100) / 100).toFixed(2)
                    ssfrs = ssfr1 + ' (LE)</br>' + ssfr6 + '&nbsp&nbsp (6:1)</br>' + ssfr10 + '&nbsp&nbsp (10:1)</br>';
                    ssfrs = ssfrs + ssfr14 + '&nbsp&nbsp (14:1)</br>' + ssfr18 + '&nbsp&nbsp (18:1)</br>';
                    ssfrs = ssfrs + ssfr25 + '&nbsp&nbsp (25:1)</br>' + ssfr35 + '&nbsp&nbsp (35:1)</br>';
                }
                else {
                    if (sfr < 0.001) {
                        ssfr = '<0.001 in/hr'
                    }
                    else {
                        ssfr = (Math.round(sfr / 25 * 10000) / 10000).toString() + ' in/hr'
                        ssfr1 = (Math.round(sfr / 25 * 1000) / 1000).toFixed(3);
                        ssfr6 = (Math.round(sfr / 25 * 6 * 100) / 100).toFixed(2)
                        ssfr10 = (Math.round(sfr / 25 * 10 * 100) / 100).toFixed(2)
                        ssfr14 = (Math.round(sfr / 25 * 14 * 100) / 100).toFixed(2)
                        ssfr18 = (Math.round(sfr / 25 * 18 * 100) / 100).toFixed(2)
                        ssfr25 = (Math.round(sfr / 25 * 25 * 100) / 100).toFixed(2)
                        ssfr35 = (Math.round(sfr / 25 * 35 * 100) / 100).toFixed(2)
                        ssfrs = ssfr1 + ' (LE)</br>' + ssfr6 + '&nbsp&nbsp (6:1)</br>' + ssfr10 + '&nbsp&nbsp (10:1)</br>';
                        ssfrs = ssfrs + ssfr14 + '&nbsp&nbsp (14:1)</br>' + ssfr18 + '&nbsp&nbsp (18:1)</br>';
                        ssfrs = ssfrs + ssfr25 + '&nbsp&nbsp (25:1)</br>' + ssfr35 + '&nbsp&nbsp (35:1)</br>';
                        // ssfrs = '<h7>' + ssfrs + '</h7>';
                    }
                }

                if (sfr !== undefined) {
                    if (config[region]["metric"]) {
                        const convertNumbersToMM = str =>
                            str.replace(/(\d+(\.\d+)?)(?=\s*\(LE\)|\s*&nbsp)/g, match =>
                                (parseFloat(match) * 25.4).toFixed(2)
                            ).replace(/(\d+(\.\d+)?)(?=\s*in\/hr)/g, match =>
                                (parseFloat(match) * 25.4).toFixed(2)
                            );

                            if (popup) {
                                popup.setMap(null);
                            }
                            
                            if (popupClass) {
                                const contentDiv = document.createElement("div");
                                contentDiv.innerHTML = `
                                <p>SFR (SLR) (mm/hr)</p>
                                <h6>${convertNumbersToMM(ssfrs)}</h6>
                                `; // or metric version
                                const newPopup = new popupClass(
                                    new window.google.maps.LatLng(latlng.lat, latlng.lng),
                                    contentDiv,
                                    () => {  
                                        newPopup.setMap(null);
                                        setPopup(null);
                                    }
                            
                                );
                                newPopup.setMap(map);
                                setPopup(newPopup);
                                setLabel(newPopup)
                            }
                    } else {
                        if (popup) {
                            popup.setMap(null);
                        }
                        
                        if (popupClass) {

                            const contentDiv = document.createElement("div");
                            contentDiv.innerHTML = `
                            <p>SFR (SLR) (in/hr)</p>
                            <h6>${ssfrs}</h6>
                            `;
                        const newPopup = new popupClass(
                                new window.google.maps.LatLng(latlng.lat, latlng.lng),
                                contentDiv,
                                () => {  
                                    newPopup.setMap(null);
                                    setPopup(null);
                                }
                            );
                            newPopup.setMap(map);
                            setPopup(newPopup);
                            setLabel(newPopup)
                        }
                }

                    // setWinCont(ssfrs);
                    // const fCont = document.getElementById('fCont');
                    // fCont.innerHTML = ssfrs;
                    // console.log('in click');
                    // console.log([e.domEvent.layerX, e.domEvent.layerY]);
                    // fwinDiv.style.left = 
                    // fwinDiv.style.top = e.domEvent.layerY -170 + 'px';
                    // fwinDiv.style.left = "40px";
                    // fwinDiv.style.top = "80px";
                    // fwinDiv.style.display = "block";
                }
            
            }
            
        }
        
    }

    useEffect(() => {
        if (!map) return;
    
        class Popup extends window.google.maps.OverlayView {
            position;
            containerDiv;
            constructor(position, content, onClose) {
                super();
                this.position = position;
                content.classList.add("popup-bubble");
                const bubbleAnchor = document.createElement("div");
                bubbleAnchor.classList.add("popup-bubble-anchor");
                bubbleAnchor.appendChild(content);

                const closeBtn = document.createElement("button");
                closeBtn.innerText = "×";
                closeBtn.classList.add("popup-close-btn");
                closeBtn.style.border = "none";
                closeBtn.style.background = "transparent";
                closeBtn.style.cursor = "pointer";
                closeBtn.style.fontSize = "20px";
                closeBtn.style.fontWeight = "bold";
                closeBtn.style.position = "absolute";
                closeBtn.style.top = "4px";
                closeBtn.style.right = "4px";
                closeBtn.style.zIndex = "10";
                closeBtn.onclick = (e) => {
                    e.stopPropagation(); 
                    if (onClose) onClose();
                };

                bubbleAnchor.appendChild(closeBtn);


                // arrow
                const arrow = document.createElement("div");
                arrow.classList.add("popup-arrow");
                bubbleAnchor.appendChild(arrow);


            

    
                this.containerDiv = document.createElement("div");
                this.containerDiv.classList.add("popup-container");
                this.containerDiv.appendChild(bubbleAnchor);

                this.containerDiv.addEventListener("click", (e) => {
                    e.stopPropagation();
                });
                
                }
    
            onAdd() {
                this.getPanes().floatPane.appendChild(this.containerDiv);
            }
    
            onRemove() {
                if (this.containerDiv.parentElement) {
                    this.containerDiv.parentElement.removeChild(this.containerDiv);
                }
            }
            
    
            draw() {
                const divPosition = this.getProjection().fromLatLngToDivPixel(this.position);
            
                const display =
                    Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000
                        ? "block"
                        : "none";
            
                if (display === "block") {
                    // offset the container so the arrow tip is at divPosition
                    const bubbleWidth = this.containerDiv.offsetWidth;
                    const bubbleHeight = this.containerDiv.offsetHeight;
                    const arrowHeight = 8; // matches CSS border-top
                    //console.log("arrowHeight", arrowHeight)
                    this.containerDiv.style.left = (divPosition.x - 75) + "px";
                    this.containerDiv.style.top = (divPosition.y - bubbleHeight - arrowHeight) + "px";
                            }
            
                if (this.containerDiv.style.display !== display) {
                    this.containerDiv.style.display = display;
                }
            }
            
                    }
    
        setPopupClass(() => Popup);
    
    }, [map]);
    

    const handleOnLoad = map => {
        /* Create and position the component for controls on the map */
        const controlButtonDiv = document.createElement('div');
        controlButtonDiv.style.paddingRight = "10px";
        controlButtonDiv.style.fontSize = "15";
        controlButtonDiv.style.fontFamily = "Roboto";
        controlButtonDiv.style.justifyContent = "center";
        controlButtonDiv.style.alignContent = "center";
        controlButtonDiv.style.display = "flex";
        const controlRoot = createRoot(controlButtonDiv);
        controlRoot.render(
            <div>
                <MapControls getParams={getParams} images={images} region={region} index={index} setIndex={setIndex} initialTransparency={transparency}/>
            </div>
        );
        map.controls[window.google.maps.ControlPosition.RIGHT_BOTTOM].push(controlButtonDiv);
        setControlsRoot(controlRoot)
        

        map.setOptions({
            zoomControlOptions: {
                position: window.google.maps.ControlPosition.TOP_RIGHT,
            }
        })

        // const xClick = (e) => {
        //     console.log(fwinDiv);
        //     fwinDiv.style.display = 'none';
        // }

        // /* Info window */
        // fwinDiv.style.zIndex = 100;
        // fwinDiv.style.fontSize = "16px";
        // fwinDiv.style.padding = "10px";
        // fwinDiv.style.width = "140px";
        // fwinDiv.style.height = "180px";
        // fwinDiv.style.background = "#eee";
        // fwinDiv.style.border = "1px solid #999";
        // fwinDiv.style.marginRight = "20px";
        // fwinDiv.style.borderRadius = "5px";
        // fwinDiv.style.position = "absolute";
        // const fwinRoot = createRoot(fwinDiv);
        // fwinRoot.render(
        //     <div id="fwin">
        //         <span>SFR (in/hr)                 </span>
        //         <button
        //         onClick={xClick}
        //         style={{
        //             background: "none",
        //             border: "none"
        //         }}
        //         >
        //             x
        //         </button>
        //         <div id="fCont"
        //             dangerouslySetInnerHTML={{__html: winCont}}
        //             style={{ padding: "5px" }}
        //         >
        //         </div>
        //     </div>
        // );
        // map.controls[window.google.maps.ControlPosition.RIGHT_BOTTOM].push(fwinDiv);


        /* Create component that shows the current image info on the map */
        const timeDiv = document.createElement('div');
        timeDiv.style.fontSize = "25px";
        timeDiv.style.fontFamily = "Roboto";
        timeDiv.style.marginTop = "10px";
        timeDiv.style.marginLeft = "10px";
        const timeRoot = createRoot(timeDiv);
        setTimeRoot(timeRoot)
        map.controls[window.google.maps.ControlPosition.TOP_LEFT].push(timeDiv);

        /* Display color bar on map */
        const colorbarDiv = document.createElement('div');
        colorbarDiv.style.paddingBottom = "10px";
        colorbarDiv.style.marginLeft = "-70px";
        const colorbarRoot = createRoot(colorbarDiv);
        // colorbarRoot.render(
        //     <div>
        //         <img src={colorbar} alt="Colorbar" className="Colorbar" width="450" />
        //     </div>
        // );
        setColorbarRoot(colorbarRoot);
        map.controls[window.google.maps.ControlPosition.BOTTOM_LEFT].push(colorbarDiv);

        /* Create drawing manager for box selection */
        const drawingManager = new window.google.maps.drawing.DrawingManager({
            drawingMode: window.google.maps.drawing.OverlayType.RECTANGLE,
            drawingControl: false
        });

        drawingManager.setMap(map);
        setDrawingManager(drawingManager);

        window.google.maps.event.addListener(drawingManager, 'rectanglecomplete', function (rectangle) {
            map.fitBounds(rectangle.bounds, 0);
            rectangle.setMap(null);
        });

        var timeout;
        window.google.maps.event.addListener(map, 'bounds_changed', function () {
            window.clearTimeout(timeout);
            timeout = window.setTimeout(function () {
                // setBounds(map.getBounds().toJSON())
                setBounds(JSON.stringify(map.getBounds()))

                const center = map.getCenter();
                const zoom = map.getZoom();
            
                setSearchParams(prev => {
                    const params = new URLSearchParams(prev);
                    params.set('img', indexRef.current);
                    params.set('opacity', opacityRef.current);
                    params.set('lat', center.lat().toFixed(2));
                    params.set('lng', center.lng().toFixed(2));
                    params.set('zoom', zoom.toFixed(2));
                    return params;
                });

            }, 100);
        });

        map.setOptions({ streetViewControl: false });
        setMap(map);
    };

    useEffect(() => {
        if (colorbarRoot && colorbar) {
            colorbarRoot.render(
                <div>
                    <img src={colorbar} alt="Colorbar" className="Colorbar" width="450" />
                </div>
            );
        }
    }, [colorbar, colorbarRoot]);

    useEffect(() => {
        cmapRef.current = cmap;
    }, [cmap]);
    
    

    /* Function that takes the image url and returns a string of the satellite, date, and time of the image */
    const imgInfo = (img) => {
        const imgRegex = /[0-9]{8}_[0-9]{6}/;
        var vals = img.match(imgRegex)[0].split('_');
        vals[0] = vals[0].substring(4, 6) + '/' + vals[0].substring(6, 8) + '/' + vals[0].substring(0, 4);
        vals[1] = vals[1].substring(0, 2) + ':' + vals[1].substring(2, 4) + ':' + vals[1].substring(4, 6) + ' UTC';
        
        const satellites = config["satellites"] || {};

        for (var key in satellites) {
            if (img.includes(key)) {
                vals.unshift(satellites[key].description_name);
                break;
            }
        }
        return vals;
    };

    // const generateGif = () => {
    //     var imgs = []

    //     for (let i = 0; i < images.length; i++) {
    //         imgs.push(images[i][0].replace("https://cics.umd.edu/~jdong/", "/home/jdong/www/"))
    //     }

    //     $.ajax({
    //         type: "GET",
    //         crossDomain: true,
    //         url: 'https://cics.umd.edu/~jdong/api/sfr/makeGif.php',
    //         data: {},
    //         xhrFields: {
    //             responseType: 'blob'
    //         },
    //         error: function (jqxhr, textstatus, errorthrown) {
    //             console.log(textstatus);
    //             console.log(errorthrown);
    //         },
    //         success: function (obj, textstatus) {
    //             console.log(obj)
    //             const link = document.createElement("a");
    //             link.href = URL.createObjectURL(obj);
    //             link.download = "sample.gif";
    //             link.click();
    //             URL.revokeObjectURL(link.href);
    //         }
    //     });
    // }

    // function handleonMouseMove(e) {
    //     console.log(e);
    //     let a = {x: e.domEvent.layerX, y: e.domEvent.layerY};
    //     console.log(a);
    //     setMousePos(a);
    // }

    return (
        <div>
            <LoadScript
                googleMapsApiKey={process.env.REACT_APP_API_KEY}
                libraries={libraries}
            // version={"beta"}
            // mapIds={[mid]}
            >
                <GoogleMap
                    mapContainerStyle={{
                        width: width + "px",
                        height: height + 'px'
                    }}

                    center={center}
                    zoom={zoom}
                    options={{
                        mapId: mid,
                        isFractionalZoomEnabled: true,
                        streetViewControl: false,
                        cameraControl: false,
                        zoomControl: true,
                        //mapTypeControl: false
                    }}
                    onLoad={map => handleOnLoad(map)}
                // onMouseMove={handleonMouseMove}
                    // onDblClick={() => generateGif()}
                    // onMouseMove={handleonMouseMove}
                >
                    {images && images[index] && images[index][0] && images[index][1] ? <GroundOverlay
                        key={images[index][0]}
                        url={images[index][0]}
                        bounds={images[index][1]}
                        opacity={transparency / 100.0}
                        onClick={(e) => handleGroundOverlayClick(e, e.latLng.toJSON(), images[index])}
                    /> : null}
                </GoogleMap>
            </LoadScript>
        </div>
    )
}

export default Map



